import axios from "axios";
import {ATHLETES_STATISTICS} from "@utils/storageKeys";
import {getSavedState, saveState} from "@utils/util";
import {Constants} from "@utils/constants";

const MIN_CACHE_MINS = 10;

export const state = {
    _athleteStatistics: getSavedState(ATHLETES_STATISTICS),
    _activeAthletes: getSavedState('athletes.activeAthletes'),
    showActiveAthletesModal: false,
    lastUpdated: getSavedState('athletes.lastUpdated'),
};

export const getters = {
};

export const mutations = {
    CACHE_ACTIVE_ATHLETES(state, athletes){
        state._activeAthletes = athletes;
        saveState('athletes.activeAthletes', athletes);
    },

    CACHE_STATISTICS(state, statistics){
        state._athleteStatistics = statistics;
    },

    CACHE_STATISTICS_TIME(state, time){
        state.lastUpdated = time;
    },

    SET_SHOW_ACTIVE_ATHLETES(state, val) {
        state.showActiveAthletesModal = val;
    },
};

export const actions = {
    cacheActiveAthletes({ state, commit }, force = false){
        // avoid fetching data if it was fetched in the last 10 minutes
        if (
            !force
            && state._activeAthletes
            && minutesBetween(new Date(), new Date(state._activeAthletes.lastUpdate)) < MIN_CACHE_MINS
        ) return;

        axios.get(`${Constants.apiUrl}/statistics/active-customers`).then(res => {
            const { activeUserIds, semiActiveUserIds } = res.data;
            commit('CACHE_ACTIVE_ATHLETES', {
                activeUserIds,
                semiActiveUserIds,
                lastUpdate: new Date()
            });
        }).catch(e => {
            console.error(e);
        });
    },

    cacheStatistics({ commit }){
        let statistics = {
            labels: [],
            athletes: {
                maleCount: 0,
                femaleCount: 0,
                newCount: [],
                lastMonthCount: [],
            },
            dietPlans: {
                newCount: 0,
                lastMonthCount: 0,
                totalCount: 0
            },
            earnings:{
                monthlyUntilToday: 0,
                expectedTillEndOfMonth: 0
            },
            events:{
                active: 0,
                cancelled: 0
            }
        };

        return axios.get(process.env.VUE_APP_API + `/athlete/statistics`,).then( result => {
            statistics.athletes.maleCount = result.data.athletes.maleCount;
            statistics.athletes.femaleCount = result.data.athletes.femaleCount;
            statistics.labels = result.data.athletes.newCount.labels;
            statistics.athletes.newCount = result.data.athletes.newCount.series;
            statistics.athletes.lastMonthCount = result.data.athletes.lastMonthNewCount.series;
            statistics.dietPlans.newCount= result.data.dietPlans.newCount.series;
            statistics.dietPlans.lastMonthCount = result.data.dietPlans.lastCount.series;
            statistics.dietPlans.totalCount = result.data.dietPlans.totalCount;
            statistics.earnings.monthlyUntilToday = result.data.earnings.monthlyUntilToday;
            statistics.earnings.expectedTillEndOfMonth = result.data.earnings.expectedTillEndOfMonth;
            statistics.events.active = result.data.events.active;
            statistics.events.cancelled = result.data.events.cancelled;
            const now = new Date();
            commit('CACHE_STATISTICS', statistics);
            commit('CACHE_STATISTICS_TIME', now);
            saveState(ATHLETES_STATISTICS, statistics);
            saveState('athletes.lastUpdated', now);
        });

    },


    refreshCacheStatistics({state, commit, dispatch}){
        if(daysBetween(new Date(), new Date(state.lastUpdated)) >= 1){
            dispatch('cacheStatistics');
        }
        commit('CACHE_STATISTICS', getSavedState(ATHLETES_STATISTICS));
        commit('CACHE_STATISTICS_TIME', getSavedState('athletes.lastUpdated'))
    },

    reset({commit}){
        commit('CACHE_STATISTICS', null);
        commit('CACHE_STATISTICS_TIME', null);
        commit('CACHE_ACTIVE_ATHLETES', null);

    }
};

// ===
// Private helpers
// ===

function daysBetween(date1, date2) {
    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);

    // Convert back to days and return
    return Math.round(differenceMs / ONE_DAY);
}

function minutesBetween(date1, date2) {
    // The number of milliseconds in one day
    const ONE_MINUTE = 1000 * 60;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);

    // Convert back to days and return
    return Math.round(differenceMs / ONE_MINUTE);
}
